import { render, staticRenderFns } from "./raio-x-regiao.vue?vue&type=template&id=9d96d280&scoped=true&"
import script from "./raio-x-regiao.vue?vue&type=script&lang=js&"
export * from "./raio-x-regiao.vue?vue&type=script&lang=js&"
import style0 from "./raio-x-regiao.vue?vue&type=style&index=0&id=9d96d280&lang=scss&scoped=true&"
import style1 from "./raio-x-regiao.vue?vue&type=style&index=1&id=9d96d280&lang=scss&scoped=true&"
import style2 from "./raio-x-regiao.vue?vue&type=style&index=2&id=9d96d280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d96d280",
  null
  
)

export default component.exports